import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ApiEndPoint } from 'src/app/shared/constants/apis.constant'
import { createPackage, PackageFilter } from '../models/package.model'

@Injectable({
	providedIn: 'root',
})
export class PackageService {
	constructor(private http: HttpClient) { }

	getPackagesList(filter: PackageFilter) {
		return this.http.post(ApiEndPoint.GetPackagesListApi, filter)
	}
	getPackage(id: number) {
		return this.http.get(`${ApiEndPoint.GetPackageDetailsApi}?id=${id}`)
	}
	uploadPackageImg(body: FormData) {
		return this.http.post(`${ApiEndPoint.UploadPackageImageApi}`, body)
	}
	createPackage(body: createPackage) {
		return this.http.post(`${ApiEndPoint.CreatePackageApi}`, body)
	}
	editPackage(body: createPackage) {
		return this.http.put(`${ApiEndPoint.EditPackageApi}`, body)
	}

	activatePackage(id:number,isActive:boolean) {
		return this.http.post(`${ApiEndPoint.ActivatePackageApi}?id=${id}&isActive=${isActive}`,{})
	}

	canBookPackage(id:number,canBook:boolean) {
		return this.http.post(`${ApiEndPoint.ChangePackageBookingApi}?id=${id}&canBook=${canBook}`,{})
	}

	deletePackage(id:number) {
		return this.http.delete(`${ApiEndPoint.DeletePackageApi}?id=${id}`)
	}
}
